import React from 'react'
import {
  Row,
  Col,
  Card,
  Button,
  Modal,
  Popconfirm,
  notification,
  Table,
} from 'antd'
import { InformfixService } from '../../../services'
import {Config} from '../../../config'
import TextArea from 'antd/lib/input/TextArea'
import { inject, observer } from 'mobx-react'
import './style.scss'
import { DeleteOutlined, UploadOutlined } from '@ant-design/icons'
import { openNotificationWithIcon } from './../../../helpers'

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = (error) => reject(error)
  })
}

@inject('informStore')
@observer
class UploadList extends React.Component {
  state = {
    previewVisible: false,
    previewImage: '',
    previewImageItem: null,
    fileList: [],
    informfixId: null,
  }

  componentDidMount() {
    this.state.fileList = this.props.informStore.itemGallery
  }

  setImgDescription = (e, item, index) => {
    const value = e.target.value || null
    if (value != item.description) {
      InformfixService.setImgDescription(item.id, {
        description: value,
      }).then((rs) => {
        let gallery = this.props.informStore.itemGallery
        gallery[index].description = value
        this.props.informStore.setGalleryItems(gallery)
        openNotificationWithIcon('success', rs.data.message)
      })
    }
  }

  previewImage = async (file) => {
    // if (!file.url && !file.preview) {
    //   file.preview = await getBase64(file.originFileObj)
    // }
    this.setState({
      previewImage: file.url || file.thumbnail,
      previewImageItem: file,
      previewVisible: true,
    })
  }

  handleCancelPreviewImage = async () => {
    this.setState({
      previewVisible: false,
    })
  }
  onRemoveImage = async (file) => {
    let informfixId = this.props.informfixId

    let gallery = this.props.informStore.itemGallery
    const index = gallery.indexOf(file)
    const nl = gallery.slice()
    nl.splice(index, 1)
    this.props.informStore.setGalleryItems(nl)

    InformfixService.deleteImage(informfixId, file.id).then((res) => {
      this.setState((state) => {
        const index = state.fileList.indexOf(file)
        const newFileList = state.fileList.slice()
        newFileList.splice(index, 1)
        return {
          fileList: newFileList,
        }
      })
      openNotificationWithIcon('success', 'ลบไฟล์เรียบร้อยแล้ว.')
      //this.props.reload()
    })
  }
  render() {
    const { fileList, informfixId, informStore } = this.props
    const { previewImage, previewImageItem, previewVisible } = this.state
    const showFileList = (items) => {
      if (items) {
        return (
          <table>
            <tbody>
              {items.length > 0
                ? items.map((file, index) => (
                    <React.Fragment key={'rf' + index}>
                      {/* <Col
                      key={'Column' + index}
                      xs={24}
                      sm={12}
                      md={12}
                      lg={12}
                      xl={12}
                    > */}
                      <tr>
                        <td>
                          {informStore.getItem.work_status !=
                          Config.informfix.status.COMPLETE.value ? (
                            <Popconfirm
                              key={'popconf' + index}
                              title={'ต้องการลบรูปภาพนี้ใช่หรือไม่ ?'}
                              onConfirm={() => this.onRemoveImage(file)}
                            >
                              <Button
                                shape="circle"
                                size="small"
                                icon={<DeleteOutlined />}
                                type="danger"
                              ></Button>
                            </Popconfirm>
                          ) : (
                            ''
                          )}
                        </td>
                        <td>
                          {' '}
                          <img
                            key={'img' + file.id}
                            style={{
                              width: 120,
                              height: 120,
                              cursor: 'pointer',
                            }}
                            src={file.url}
                            onClick={() => this.previewImage(file)}
                          />
                        </td>
                        <td>
                          <TextArea
                            style={{
                              width: '100%',
                            }}
                            key={'desc' + index}
                            defaultValue={file.description}
                            onBlur={(e) =>
                              this.setImgDescription(e, file, index)
                            }
                          ></TextArea>
                        </td>
                      </tr>
                    </React.Fragment>
                  ))
                : null}
            </tbody>
          </table>
        )
      }
    }
    return (
      <div>
        {informStore.itemGallery ? showFileList(informStore.itemGallery) : null}
        <Modal
          className="modal-preview"
          title={previewImageItem ? previewImageItem.name : null}
          open={previewVisible}
          footer={
            <div align="left">
              {previewImageItem ? previewImageItem.description : null}
            </div>
          }
          onCancel={this.handleCancelPreviewImage}
        >
          <img style={{ width: '100%' }} src={previewImage} />
        </Modal>
      </div>
    )
  }
}

export default UploadList
